<template>
  <div class="pb-24 md:pb-0">
    <NewNavbar variant="standard" />
    <nuxt />
    <OFooter
      :locale="locale"
      :year="$moment().format('YYYY')"
      :faq-column="footer.faqColumn"
      :how-does-it-work-column="footer.howDoesItWorkColumn"
      :legal-column="footer.legalColumn"
    />
    <SupportBubble :locale="locale" icon-only />
  </div>
</template>

<script>
import NewNavbar from '@/components/NewNavbar'
import metaMixin from '@/mixins/meta'
import footerMixin from '@/mixins/footer'
import SupportBubble from '@/components/SupportBubble'
import OFooter from '@/components/OFooter'
import { mapState } from 'vuex'

export default {
  name: 'HomePageLayout',
  middleware: 'homepage',
  components: { NewNavbar, SupportBubble, OFooter },
  mixins: [metaMixin, footerMixin],
  computed: {
    ...mapState('app', {
      locale: state => state.locale
    })
  },
  head () {
    return {
      title: this.metaTitle
    }
  }
}
</script>

<style>

</style>
